export default __webpack_public_path__ + "static/media/modalBanner.ea87ca12.svg";